export type ViewMode = 'inbox' | 'room';
export const VIEWMODE_INBOX: ViewMode = 'inbox';
export const VIEWMODE_ROOM: ViewMode = 'room';
